import React, { useState, useRef, useEffect } from 'react';
import styles from './index.module.scss';

const DEFAULT_CANVAS_NAME = '未命名画布';
const ICON_BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/freeCanvas/';
const UP_DOWN_ICON = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/freeCanvas/updown.svg';
const BACK_ICON = `${ICON_BASE_URL}backIcon.svg`;
const LIST_ICON = `${ICON_BASE_URL}listIcon.svg`;
const CREATE_ICON = `${ICON_BASE_URL}createIcon.svg`;

const ProjectHeader = ({
    name,
    onNameChange,
    onBack,
    onOpenProjectList,
    onCreateProject,
    sidebarCollapsed = true,
    editable = true,
    createDisabled = false,
}) => {
    const [editing, setEditing] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const displayName = name || DEFAULT_CANVAS_NAME;
    const displayLabel = String(displayName).slice(0, 20);
    const [value, setValue] = useState(displayName);
    const inputRef = useRef(null);
    const wrapperRef = useRef(null);

    useEffect(() => {
        setValue(displayName);
    }, [displayName]);

    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [editing]);

    useEffect(() => {
        if (!menuOpen) return undefined;

        const handlePointerDown = (event) => {
            if (wrapperRef.current?.contains(event.target)) return;
            setMenuOpen(false);
        };

        document.addEventListener('mousedown', handlePointerDown);
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
        };
    }, [menuOpen]);

    const handleConfirm = () => {
        setEditing(false);
        if (!editable) {
            setValue(displayName);
            return;
        }
        const trimmed = value.trim().slice(0, 20);
        if (trimmed && trimmed !== displayName) {
            onNameChange?.(trimmed);
        } else {
            setValue(displayName);
        }
    };

    return (
        <>
            <div className={styles.logo}>
                <i className={styles.logoMark} aria-hidden="true"></i>
            </div>
            <div
                ref={wrapperRef}
                className={`${styles.wrapper} ${sidebarCollapsed ? '' : styles.wrapperShifted}`}
            >
                <button
                    type="button"
                    className={styles.exitButton}
                    onClick={() => onBack?.()}
                >
                    <img className={styles.exitIcon} src={BACK_ICON} alt="退出画布" />
                </button>
                <span className={styles.divider} aria-hidden="true"></span>
                {editing && editable ? (
                    <input
                        ref={inputRef}
                        className={styles.input}
                        value={value}
                        maxLength={20}
                        onChange={e => setValue((e.target.value || '').slice(0, 20))}
                        onBlur={handleConfirm}
                        onKeyDown={e => { if (e.key === 'Enter') handleConfirm(); }}
                    />
                ) : (
                    <span className={styles.nameAction}>
                        <button
                            type="button"
                            className={styles.nameButton}
                            title={displayName}
                            onClick={() => {
                                if (!editable) return;
                                setEditing(true);
                            }}
                        >
                            <span className={styles.name}>
                                {displayLabel}
                            </span>
                        </button>
                        <button
                            type="button"
                            className={styles.arrowButton}
                            onClick={(event) => {
                                event.stopPropagation();
                                setMenuOpen((prev) => !prev);
                            }}
                        >
                            <span className={`${styles.arrowIcon} ${menuOpen ? styles.arrowIconOpen : ''}`}>
                                <img src={UP_DOWN_ICON} alt="展开菜单" width={16} height={16} />
                            </span>
                        </button>
                    </span>
                )}
                {menuOpen ? (
                    <div className={styles.dropdown}>
                        <button
                            type="button"
                            className={styles.menuItem}
                            onClick={() => {
                                setMenuOpen(false);
                                onOpenProjectList?.();
                            }}
                        >
                            <img className={styles.menuIcon} src={LIST_ICON} alt="" />
                            <span>项目列表</span>
                        </button>
                        <button
                            type="button"
                            className={`${styles.menuItem} ${createDisabled ? styles.menuItemDisabled : ''}`}
                            disabled={createDisabled}
                            onClick={() => {
                                if (createDisabled) return;
                                setMenuOpen(false);
                                onCreateProject?.();
                            }}
                        >
                            <img className={styles.menuIcon} src={CREATE_ICON} alt="" />
                            <span>新建项目</span>
                        </button>
                    </div>
                ) : null}
            </div>
        </>
    );
};

export default ProjectHeader;
